import { GameState } from "../../App";
import { PlayerService } from "../../services/PlayerService";
import dice from "../../assets/dice.gif";
import { useState } from "react";
import './Player-Reroll.scss';

interface PlayerRerollProps {
    playerService: PlayerService;
    setGameState: (gameState: GameState) => void;
}

export const PlayerReroll: React.FC<PlayerRerollProps> = ({playerService, setGameState}) => {
    const [player, setPlayer] = useState('');
    const [oldPlayer] = useState(playerService.getCurrentPlayer().name);
    
    const onClickPlayer = () => {
        console.log(playerService.getCurrentPlayer().name);
        playerService.randomizePlayer();
        setPlayer(playerService.getCurrentPlayer().name);
    }
    
    return (
        <>
            <div className={'failure-message'}>Oops! Looks like you need to drink an ice, {oldPlayer}!</div>
            <div className={'reroll-message'}>Reroll for a new player!</div>
            <button className={'dice-button'} onClick={onClickPlayer}><img src={dice} className={'dice'} alt="d20"/></button>
            {player !== '' && (
                <div className={'retry-button'}>
                    <div className={'retry-person'}>{player}, you're up!</div>
                    <button onClick={() => setGameState('playing')}>Retry!</button>
                </div>
            )}
        </>
    )
}